import { useEffect, useState } from "react";

function getImageIdentity(url: string): string {
  try {
    const parsedUrl = new URL(url);

    return `${parsedUrl.origin}${parsedUrl.pathname}`;
  } catch {
    return url;
  }
}

export function useStableImageUrl(url?: string): string | undefined {
  const [stableUrl, setStableUrl] = useState<string | undefined>();

  useEffect(() => {
    if (!url) {
      setStableUrl(undefined);

      return;
    }

    setStableUrl((previousUrl) => {
      if (!previousUrl) return url;

      const previousIdentity = getImageIdentity(previousUrl);
      const nextIdentity = getImageIdentity(url);

      return previousIdentity === nextIdentity ? previousUrl : url;
    });
  }, [url]);

  return stableUrl;
}
